import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
const nameFirstChar = (name) => {
  return (name = name.charAt(0));
};
export default ({ session, allSessions, index }) => {
  return (
    <Col
      lg={12}
      md={12}
      sm={12}
      xs={12}
      style={{
        borderBottom:
          allSessions.length - 1 !== index ? "1px solid #ced4da" : "",
        padding: "0",
      }}
    >
      <Row className="flex-center">
        <Col xs={12}>
          <div className="time-style">
            <span>{session?.date}<span className="unary-or"> | </span>{session?.time}<span className="unary-or"> | </span>{session?.status}</span>
          </div>
        </Col>
        <Col
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="flex-end-center btn-session"
        >
          {/* <Button className="rate-style">{`23.00`}</Button>
                <Button className="accept">Accept</Button>
                <Button className="decline">Decline</Button> */}
        </Col>
      </Row>
      <Row className="flex-center">
        <Col xs={12}>
          <Link
            style={{ "text-decoration": "none" }}
            to={`/tutor-dashboard/lessonDetails`}
          >
            <div className="session-info">
              <div>
                <h5 className="green-txt">Request<span className="margin-btw">{session?.name.substring(0, session.name.indexOf(" "))}</span></h5>
                <div className="s-notes">{session?.notes}</div>
                <p className="subject">{`${session?.subject} - £20/lesson`}</p>
              </div>
              <div className="circle-content">
                {session?.name ? (
                  <h2 className="circle-text">{nameFirstChar(session?.name)}</h2>
                ) : (
                  ""
                )}
                </div>
            </div>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};
